module.exports = __webpack_public_path__ + "static/img/几何模型.dd7d8fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/几何模型.jpg
// module id = dhK2
// module chunks = 1